<template>
  <div class="p-point-notation" :style="fontStyle">
    <i v-if="iconSize !== false" class="p-point-notation__icon">
      <slot name="icon">
        <IconPoint
          :icon-size="iconSize"
          :icon-sp-size="iconSpSize"
          :point_logo="point_logo"
        />
      </slot>
    </i>
    <div class="p-point-notation__point" data-translate-skip>
      <span class="p-point-notation__point__num" :style="fontStyle">{{
        addComma(point)
      }}</span>
      <span
        class="p-point-notation__point__unit"
        :style="{ fontSize: `${fontSize / 2 / 16}rem` }" data-translate-skip
        >{{ getUnit() }}</span
      >
    </div>
    <span
      v-if="signIsExists"
      class="p-point-notation__sign"
      :class="`p-point-notation__sign--${getSignData.signClassName}`"
      >{{ getSignData.signLabel }}</span
    >
  </div>
</template>

<script lang="ts">
import IconPoint from "@/common/components/icons/IconPoint.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";
import store from "@/general/store";

@Options({
  props: {
    fontSize: {
      type: Number,
      default: 24
    },
    iconSize: {
      type: [Boolean, Number],
      default: false
    },
    iconSpSize: {
      type: [Boolean, Number],
      default: false
    },
    point: {
      type: Number,
      required: true
    },
    pointColor: {
      type: [Boolean, String],
      default: "#000"
    },
    sign: {
      type: Boolean,
      default: true
    },
    signIsExists: {
      type: [Boolean, String],
      default: true
    },
    unit: {
      type: [Object]
    },
    point_logo: {
      type: String,
      default: ""
    }
  },
  components: {
    IconPoint
  },
  store: store
})
export default class PointNotation extends Vue {
  fontSize!: number;
  iconSize!: number | boolean;
  iconSpSize!: number | boolean;
  point!: number;
  pointColor!: string | boolean;
  sign!: boolean;
  signIsExists!: string | boolean;
  unit!: any;
  point_logo: string;

  get getSignData() {
    const sign = this.sign;
    const signClassName = sign ? "plus" : "minus";
    const signLabel = sign ? "+" : "-";

    return { signClassName, signLabel };
  }

  get unitProp() {
    return this.unit;
  }
  getUnit() {
    if (commons?.OrgPageSpecific?.point_name) {
      return commons?.OrgPageSpecific?.point_name;
    }
    return commons?.unit?.point;
  }

  get fontStyle() {
    return { color: this.pointColor, fontSize: `${this.fontSize / 16}rem` };
  }
  
  addComma(value: any): string {
    const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
}
</script>

<style lang="scss" scoped>
.p-point-notation {
  font-family: $font--roboto;
  display: flex;
  align-items: center;

  &__icon {
    @include pc {
      margin: 0 0.5em 0 0;
    }
    @include sp {
      margin: 0 (8 / 28 * 1em) 0 0;
    }
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__point {
    font-size: 0;
    line-height: 1.6;
    // DX_IC-723 ポイント名が改行しないように対応する
    white-space: nowrap;

    &__num {
      font-family: 'Noto Sans JP';
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      align-items: center;
      font-feature-settings: 'palt' on, 'pwid' on;
      color: $common-black;
      display: inline;
    }

    &__unit {
      font-family: 'Noto Sans JP';
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 1.6;
      align-items: center;
      font-feature-settings: 'palt' on, 'pwid' on;
      color: $common-black;
      display: inline;
    }
  }

  &__sign {
    margin: 0 0 0 rem(10);
    display: block;
    font-size: em(32 / 48);
    min-width: rem(12);
    text-align: center;

    &--plus {
      color: #075cce;
    }

    &--minus {
      color: $common-primary;
    }
  }
}
</style>
